import axios from 'axios'
import queryString from 'query-string'

import { ERROR_MESSAGE_DELETING_FILE, ERROR_MESSAGE_DOWNLOADING_FILE, ERROR_MESSAGE_SAVING } from '../constants'
import { reportFileUploadError } from '../helpers/sentry'
import { formatFileUploadErrorMessage, formatFileUploadSuccessMessage, truncateTextMiddle } from '../helpers/strings'
import { receiveSuccessAlert } from './alerts'
import { handleRequestError } from './request'

export const DELETE_TAX_RETURN_FILE = 'DELETE_TAX_RETURN_FILE'
export const DOWNLOAD_TAX_RETURN_FILE = 'DOWNLOAD_TAX_RETURN_FILE'
export const RECEIVE_TAX_RETURN_FILES = 'RECEIVE_TAX_RETURN_FILES'
export const REMOVE_AND_DELETE_TAX_RETURN_FILE = 'REMOVE_AND_DELETE_TAX_RETURN_FILE'
export const REMOVE_TAX_RETURN_FILE = 'REMOVE_TAX_RETURN_FILE'
export const REQUEST_TAX_RETURN_FILES = 'REQUEST_TAX_RETURN_FILES'
export const SAVE_TAX_RETURN_FILE = 'SAVE_TAX_RETURN_FILE'
export const UPDATE_AND_SAVE_TAX_RETURN_FILE = 'UPDATE_AND_SAVE_TAX_RETURN_FILE'
export const UPLOAD_TAX_RETURN_FILE = 'UPLOAD_TAX_RETURN_FILE'

export const requestTaxReturnFiles = (taxReturnId) => (dispatch, getState) => {
    const { id: activeTaxReturnId } = getState().taxReturn
    const id = taxReturnId ?? activeTaxReturnId

    dispatch({ type: REQUEST_TAX_RETURN_FILES, data: { taxReturnId: taxReturnId || id } })

    return axios
        .get(`/files?taxReturnId=${taxReturnId || id}`)
        .then((response) => {
            const items = response?.data || []
            dispatch(receiveTaxReturnFiles({ items, fetchSuccessful: true }))
        })
        .catch((error) => {
            dispatch(receiveTaxReturnFiles({ fetchSuccessful: false }))

            dispatch(handleRequestError(error))
        })
}

export const receiveTaxReturnFiles = (data) => ({ type: RECEIVE_TAX_RETURN_FILES, data })

export const uploadTaxReturnFile = (data) => (dispatch, getState) => {
    dispatch({ type: UPLOAD_TAX_RETURN_FILE, data })

    const { taxReturn } = getState()

    const { file, fileSubType, fileType, filingArea, taxReturnId } = data

    const params = {
        taxReturnId: taxReturnId || taxReturn.id,
        ...(fileSubType && { fileSubType }),
        ...(fileType && { fileType }),
        ...(filingArea && { filingArea }),
    }

    const formData = new FormData()
    formData.append('file', file)

    axios
        .post(`/file/?${queryString.stringify(params)}`, formData, {
            headers: {
                'content-type': 'multipart/form-data',
            },
        })
        .then(() => {
            dispatch(receiveSuccessAlert(formatFileUploadSuccessMessage(file?.name)))

            dispatch(requestTaxReturnFiles(taxReturnId || taxReturn.id))
        })
        .catch((error) => {
            reportFileUploadError(error, file)
            dispatch(handleRequestError(error, { customMessage: formatFileUploadErrorMessage(file?.name) }))
        })
}

export const removeAndDeleteTaxReturnFile =
    (data, options = {}) =>
    (dispatch) => {
        dispatch({ type: REMOVE_AND_DELETE_TAX_RETURN_FILE, data })

        dispatch(removeTaxReturnFile(data))
        dispatch(deleteTaxReturnFile(data, options))
    }

export const removeTaxReturnFile = (data) => ({ type: REMOVE_TAX_RETURN_FILE, data })

export const deleteTaxReturnFile =
    (data, { hideAlert = false } = {}) =>
    (dispatch) => {
        dispatch({ type: DELETE_TAX_RETURN_FILE, data })

        const { id, fileName } = data

        axios
            .delete(`/file/${id}`)
            .then(() => {
                dispatch(removeTaxReturnFile({ id }))

                if (!hideAlert) {
                    dispatch(
                        receiveSuccessAlert(`Archivo ${fileName ? `"${truncateTextMiddle(fileName)}"` : ''} eliminado`)
                    )
                }
            })
            .catch((error) => {
                dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_DELETING_FILE }))
            })
    }

export const updateAndSaveTaxReturnFile = (data) => (dispatch) => {
    dispatch({ type: UPDATE_AND_SAVE_TAX_RETURN_FILE, data })

    dispatch(receiveTaxReturnFiles({ items: [data] }))
    dispatch(saveTaxReturnFile(data))
}

export const saveTaxReturnFile = (data) => (dispatch) => {
    dispatch({ type: SAVE_TAX_RETURN_FILE, data })

    const { id } = data

    axios
        .put(`/file/${id}`, data)
        .then((response) => {
            const item = response?.data

            if (!item) return

            dispatch(receiveTaxReturnFiles({ items: [item] }))
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
        })
}

export const downloadTaxReturnFile =
    (data, { onSuccess } = {}) =>
    (dispatch) => {
        dispatch({ type: DOWNLOAD_TAX_RETURN_FILE, data })

        const { id } = data

        axios
            .get(`/file/${id}/downloadlink`)
            .then((response) => {
                if (response.data) {
                    window.location.assign(response.data)
                    if (onSuccess) {
                        onSuccess()
                    }
                }
            })
            .catch((error) => {
                dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_DOWNLOADING_FILE }))
            })
    }
